// Phase 1 (iter1): 全 Lens 共通の選択 item 状態 (Context 経由で AppV2 の Detail slot に連携)
import { createContext, useCallback, useContext, useMemo, useState } from 'react'

export interface SelectedDetailItem {
  id: string
  itemType: 'entry' | 'article'
}

interface Ctx {
  selectedItem: SelectedDetailItem | null
  setSelectedItem: (item: SelectedDetailItem | null) => void
}

const SelectedItemCtx = createContext<Ctx | null>(null)

export function SelectedItemProvider({ children }: { children: React.ReactNode }) {
  const [selectedItem, setSelectedItemRaw] = useState<SelectedDetailItem | null>(null)
  const setSelectedItem = useCallback((item: SelectedDetailItem | null) => setSelectedItemRaw(item), [])
  const value = useMemo(() => ({ selectedItem, setSelectedItem }), [selectedItem, setSelectedItem])
  return <SelectedItemCtx.Provider value={value}>{children}</SelectedItemCtx.Provider>
}

export function useSelectedItem(): Ctx {
  const v = useContext(SelectedItemCtx)
  if (!v) throw new Error('useSelectedItem must be within SelectedItemProvider')
  return v
}
